import { render, staticRenderFns } from "./VaMediumEditor.vue?vue&type=template&id=aa37a154&"
import script from "./VaMediumEditor.vue?vue&type=script&lang=js&"
export * from "./VaMediumEditor.vue?vue&type=script&lang=js&"
import style0 from "./VaMediumEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports